import React, { useState } from 'react';
import { Check, AlertCircleIcon } from 'lucide-react';
import { packages } from '../data/packages';
const inputClass = 'w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors duration-150';
const labelClass = 'block text-sm font-bold text-gray-700 uppercase tracking-wider';

/** Quote request form (submits through the existing Web3Forms account). */
export function ContactForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setIsError(false);
    const form = e.currentTarget;
    const formData = new FormData(form);
    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(Object.fromEntries(formData))
      });
      const data = await response.json().catch(() => null);
      if (response.ok && data && data.success) {
        setIsSuccess(true);
        form.reset();
      } else {
        setIsError(true);
      }
    } catch {
      setIsError(true);
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 shadow-xl" id="quote-form" data-id="element-85" data-mp="3bmgnudrqljcl">
      {isSuccess ? <div className="flex flex-col items-center justify-center py-12 text-center" role="status" data-id="element-86" data-mp="3gixat4n79ro3">
          <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mb-6" data-id="element-87" data-mp="3knn7gvponaa2">
            <Check className="w-8 h-8 text-green-600" aria-hidden="true" data-id="element-88" data-mp="vtzti7znmdob" />
          </div>
          <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-89" data-mp="zu9xxg7ssw12">
            Quote Request Sent!
          </h3>
          <p className="text-gray-600 mb-6" data-id="element-90" data-mp="2wunyelbn12p8">
            Thank you for reaching out. Mike will get back to you shortly.
          </p>
          <button type="button" onClick={() => setIsSuccess(false)} className="text-blue-600 font-bold hover:underline" data-id="element-91" data-mp="35x70v4bihday">
            Send another request
          </button>
        </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-92" data-mp="30w9hioermd7v">
          <div data-id="element-93" data-mp="2d9b3ryi15jdn">
            <h2 className="text-2xl md:text-3xl font-black uppercase text-gray-900" data-id="element-94" data-mp="2d8rlggogwsz3">
              Request a Quote
            </h2>
            <p className="mt-1 text-gray-600" data-id="element-95" data-mp="2myb69rvqqwwl">
              Fill out the form and we will send you a custom quote. Fields
              marked * are required.
            </p>
          </div>

          <input type="hidden" name="access_key" value="117a1b08-1717-47b9-b0bd-edf47d626a50" data-id="element-96" data-mp="2i5rqco9kzpom" />
          <input type="hidden" name="subject" value="New Quote Request - Mike's Pro Detail" data-id="element-97" data-mp="1ufnpuprow61u" />
          <input type="hidden" name="from_name" value="Mike's Pro Detail Website" data-id="element-98" data-mp="1pguizg6wrdan" />

          {isError && <div className="flex items-center gap-3 p-4 bg-red-50 border border-red-200 rounded-lg text-red-700" role="alert" data-id="element-99" data-mp="4ys5ovj4bsan">
              <AlertCircleIcon className="w-5 h-5 flex-shrink-0" aria-hidden="true" data-id="element-100" data-mp="3s5uj84jolrev" />
              <p className="text-sm font-medium" data-id="element-101" data-mp="zay9wk4sl2u">
                Something went wrong. Please try again or call or text (818)
                381-9905 directly.
              </p>
            </div>}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-102" data-mp="sqh2ao2z32xe">
            <div className="space-y-2" data-id="element-103" data-mp="spxmbcwvuom0">
              <label htmlFor="name" className={labelClass} data-id="element-104" data-mp="eqy70vv9fm2i">Name *</label>
              <input type="text" id="name" name="name" required autoComplete="name" className={inputClass} placeholder="John Doe" data-id="element-105" data-mp="essg9cx65pqr" />
            </div>
            <div className="space-y-2" data-id="element-106" data-mp="2zgnj514kwtri">
              <label htmlFor="phone" className={labelClass} data-id="element-107" data-mp="2zflx61m0ymv0">Phone *</label>
              <input type="tel" id="phone" name="phone" required autoComplete="tel" pattern="[\d\s\-\+\(\)\.]{7,}" className={inputClass} placeholder="(555) 123-4567" data-id="element-108" data-mp="34gt643zwls39" />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-109" data-mp="3ey540sauawyt">
            <div className="space-y-2" data-id="element-110" data-mp="3awtmla24di1p">
              <label htmlFor="email" className={labelClass} data-id="element-111" data-mp="3axuuj5nu9of7">Email</label>
              <input type="email" id="email" name="email" autoComplete="email" className={inputClass} placeholder="john@example.com" data-id="element-112" data-mp="35zb9d7h2kgnw" />
            </div>
            <div className="space-y-2" data-id="element-113" data-mp="6gshdfokgqtp">
              <label htmlFor="vehicle" className={labelClass} data-id="element-114" data-mp="2h9wul0nqhre">Vehicle</label>
              <input type="text" id="vehicle" name="vehicle" className={inputClass} placeholder="e.g. 2023 Tesla Model 3" data-id="element-115" data-mp="3tnkpptvikc7n" />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-116" data-mp="3oohvl4h2nqeg">
            <div className="space-y-2" data-id="element-117" data-mp="2i8xoc0wwji2t">
              <label htmlFor="service" className={labelClass} data-id="element-118" data-mp="2i6kyz2ote5fq">Service Requested *</label>
              <select id="service" name="service" required defaultValue="" className={`${inputClass} appearance-none pr-10`} style={{
            backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%239ca3af' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
            backgroundPosition: 'right 0.5rem center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '1.5em 1.5em'
          }} data-id="element-119" data-mp="2d89p4ryiruxi">
                <option value="" disabled data-id="element-120" data-mp="2quytepy0js9t">Select a service...</option>
                {packages.map(pkg => <option key={pkg.slug} value={pkg.name} data-id="element-121" data-mp="2vul2qoaq0odc">{pkg.name}</option>)}
                <option value="Engine Bay Cleaning" data-id="element-122" data-mp="2vs8retzgxc99">Engine Bay Cleaning</option>
                <option value="Others" data-id="element-123" data-mp="30smxw7lf8e56">Others</option>
              </select>
            </div>
            <div className="space-y-2" data-id="element-124" data-mp="11hvaeb003n82">
              <label htmlFor="preferred_date" className={labelClass} data-id="element-125" data-mp="16fdmubd88kkt">Preferred Date</label>
              <input type="date" id="preferred_date" name="preferred_date" className={inputClass} data-id="element-126" data-mp="16h83veldnsjm" />
            </div>
          </div>

          <div className="space-y-2" data-id="element-127" data-mp="tge6pozd0o29">
            <label htmlFor="source" className={labelClass} data-id="element-128" data-mp="thfijvo79el1">Where did you hear about us?</label>
            <input type="text" id="source" name="source" className={inputClass} placeholder="Google, Yelp, Friend, etc." data-id="element-129" data-mp="18eg8btmtyzgv" />
          </div>

          <div className="space-y-2" data-id="element-130" data-mp="1hdjs6zttniwf">
            <label htmlFor="message" className={labelClass} data-id="element-131" data-mp="1hcia4bee1w57">Message</label>
            <textarea id="message" name="message" rows={4} className={`${inputClass} resize-none`} placeholder="Tell us more about what you need..." data-id="element-132" data-mp="1cf09d8aiyn8a" />
          </div>

          <button type="submit" disabled={isSubmitting} className="w-full py-4 bg-red-600 hover:bg-red-500 text-white font-black text-lg uppercase tracking-wider rounded-lg transition-colors duration-150 disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2" data-id="element-133" data-mp="1r57hau2wonuq">
            {isSubmitting ? <>
                <svg className="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24" fill="none" aria-hidden="true" data-id="element-134" data-mp="2eq8efhwfyz32">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-135" data-mp="2jos0rjey6cvy" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" data-id="element-136" data-mp="25pa8uv6cujid" />
                </svg>
                Sending...
              </> : 'Request a Quote'}
          </button>
        </form>}
    </div>;
}